export const formAddProject = "add-project";
export const formAddSource = "add-source";
export const formAddSourceCode = "add-source-code";
export const formAddTopic = "add-topic";
export const formAddUser = "add-user";
export const formChangeTitleAnswer = "change-title-answer";
export const formDeleteAccount = "delete-account";
export const formEditProject = "edit-project";
export const formEditTopic = "edit-topic";
export const formEditUser = "edit-user";
export const formLogin = "login-form";
export const formRegisterAnagrafica = "register-anagrafica";
export const formResetPassword = "reset-password";
export const formSendMessage = "send-message";
export const formSetRegisterPassword = "set-register-password";
export const formShareProject = "share-project";
export const formShareAnswers = "share-pinned-answers";
export const formUpdateAnagrafica = "update-anagrafica";
export const formUpdatePassword = "update-password";
export const formEditReportedAnswer = "edit-reported-answer";
export const formSendFeedback = "send-feedback";
